import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "oxd-report-table-header" }
const _hoisted_2 = { class: "oxd-report-table-header--toggable" }
const _hoisted_3 = { class: "oxd-report-table-header--pagination" }
const _hoisted_4 = {
  key: 0,
  class: "oxd-report-table-loader"
}
const _hoisted_5 = { class: "oxd-report-table-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_loading_spinner = _resolveComponent("oxd-loading-spinner")!
  const _component_v_grid = _resolveComponent("v-grid")!

  return (_openBlock(), _createElementBlock("div", {
    onFullscreenchange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFullScreenChange && _ctx.onFullScreenChange(...args))),
    ref: "tableRef",
    class: _normalizeClass(_ctx.classes)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_oxd_icon_button, {
          class: "--toggable-icon",
          name: _ctx.fullScreenIcon,
          withContainer: false,
          onClick: _ctx.toggleFullScreen
        }, null, 8, ["name", "onClick"]),
        (_ctx.hasScrolling)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_oxd_icon_button, {
                class: "--toggable-icon",
                name: "chevron-left",
                withContainer: false,
                onClick: _ctx.scrollLeft
              }, null, 8, ["onClick"]),
              _createVNode(_component_oxd_icon_button, {
                class: "--toggable-icon",
                name: "chevron-right",
                withContainer: false,
                onClick: _ctx.scrollRight
              }, null, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "toggable")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "pagination")
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_oxd_loading_spinner)
        ]))
      : (_openBlock(), _createBlock(_component_v_grid, _mergeProps({
          ref: "vgridRef",
          theme: "compact",
          key: _ctx.key,
          source: _ctx.items,
          columns: _ctx.headers,
          readonly: true,
          resize: true,
          canFocus: false,
          colSize: _ctx.colSize,
          "row-definitions": _ctx.rowDefinitions
        }, _ctx.$attrs), null, 16, ["source", "columns", "colSize", "row-definitions"])),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "footer")
    ])
  ], 34))
}